// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	let form_salesforce = document.querySelector( "#form_id-946" );

	if( form_salesforce ){

		form_salesforce.addEventListener( "submit", () => {

			let post = {
				operation: "salesforce_group_up",
				oid: "00DHs000000QMCj",
				retURL: "https://www.zipscarwash.com/",
				first_name: $( "[name=first_name]" ).val(),
				last_name: $( "[name=last_name]" ).val(),
				email: $( "[name=email_address]" ).val(),
				phone: $( "[name=phone_number]" ).val(),
				company: $( "[name=company_name]" ).val(),
				street: $( "[name=address]" ).val(),
				city: $( "[name=city]" ).val(),
				state: $( "[name=state]" ).val(),
				zip: $( "[name=zip_code]" ).val(),
				_token: $( "[name=_token]" ).val(),
				industry: document.querySelector("[name=industry]").options[document.querySelector("[name=industry]").selectedIndex].text,
				"00NHs00000ILLTo": $( "[name=how_many_vehicles_do_you_want_to_wash]" ).val(),
				"00NHs00000ILLTy": $( "[name=additional_info_or_comments]" ).val(),
				"00NHs00000IM93j": "External",
			}

			$.post( "/ajax/functions.php", post, () => {

				

			} )

		} )

	}

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		$('.no-action').click(function(event) {
			e.preventDefault();
		}); 

		let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
		itemsMenu.forEach((itemMenu)=>{
			if(itemMenu.querySelector('.submenu')){
				itemMenu.addEventListener('mouseenter',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
				});
				itemMenu.addEventListener('mouseleave',()=>{
					itemMenu.classList.remove('hover');
					itemMenu.querySelector('.submenu').classList.remove('show');
				})
			}
			if(itemMenu.querySelector('.submenu')){
				let submenus = itemMenu.querySelectorAll('.submenu li a');

				submenus.forEach( link => {
					link.setAttribute("tabindex", 0)
				})

				itemMenu.addEventListener('click',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.toggle('show');
					
				});
				
			}
			itemMenu.addEventListener('focusin',()=>{
				document.querySelectorAll('.submenu').forEach(submenu => {
					submenu.classList.remove('show');
				});
			});

			if(itemMenu.querySelector('.submenu')){
				itemMenu.addEventListener('focusin',()=>{
					itemMenu.classList.add('hover');
					itemMenu.querySelector('.submenu').classList.add('show');
					
					let submenus = itemMenu.querySelectorAll('.submenu li a');

					submenus.forEach( link => {
						link.setAttribute("tabindex", 0)
					})
				});
			}
			document.querySelectorAll('.js-close-menu').forEach(btn => {
			btn.addEventListener('click', () => {
				document.getElementById('burger-menu').classList.remove('open');
			});
		});
		})
	
		// scrollDownAction(20, 'scroll');
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });



		


		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	}; 

}()); 
 
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code 
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up'); 
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			} 
		}  
	} else {   
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}